<template>
  <div
    :class="[{ '--loading': isLoading }, 'external-auth-buttons p-relative']"
  >
    <iframe
      ref="auth-buttons"
      class="external-auth-buttons__iframe p-relative z-2"
      :style="{ height: `${60 * shownProviders.length}px` }"
      :src="src"
    />

    <div
      class="external-auth-buttons__placeholder p-overlay d-flex flex-column z-1"
    >
      <placeholder-rect
        v-for="provider in shownProviders"
        :key="provider"
        class="mx-0 mt-0 mb-1"
        full-width
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import AUTH_PROVIDERS from "@shared/auth-providers.json"

import { getImageUrl } from "@/lib/utils"
import EventBus, { EVENTS } from "@/lib/event-bus"

import PlaceholderRect from "@/components/PlaceholderRect"

export default {
  components: {
    PlaceholderRect
  },

  props: {
    providers: {
      type: Array,
      default: () => Object.values(AUTH_PROVIDERS)
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      authHost: process.env.VUE_APP_AUTH_HOST
    }
  },

  computed: {
    ...mapGetters(["appName", "appIcon"]),

    shownProviders() {
      return this.providers.filter(
        p =>
          !(p === AUTH_PROVIDERS.default || p === AUTH_PROVIDERS.passwordless)
      )
    },

    src() {
      let queryString = `providers=${this.shownProviders.join(",")}`

      if (this.appIcon) {
        queryString += `&icon=${btoa(getImageUrl(this.appIcon))}`
      }

      if (this.appName) {
        queryString += `&name=${encodeURI(this.appName)}`
      }

      queryString += `&apple_text=${encodeURI(
        this.$t("components.auth.externalAuthButtons.apple")
      )}`
      queryString += `&google_text=${encodeURI(
        this.$t("components.auth.externalAuthButtons.google")
      )}`

      return `${this.authHost}?${queryString}`
    }
  },

  mounted() {
    window.addEventListener("message", this.handleMessage, false)
    EventBus.$on(EVENTS.NATIVE_AUTHENTICATED, this.handleEvent)
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage)
    EventBus.$off(EVENTS.NATIVE_AUTHENTICATED, this.handleEvent)
  },

  methods: {
    handleMessage(event) {
      if (event.origin === this.authHost && event.data) {
        this.handleEvent(JSON.parse(event.data))
      }
    },

    handleEvent(event) {
      switch (event.type) {
        case "authenticated":
          this.$emit("success", event.data)
          break

        default:
          console.log("Unknown event type", event.type)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/animations";

.external-auth-buttons {
  &.--loading {
    animation: load-pulse 1.6s ease infinite;
    pointer-events: none;
  }
}

.external-auth-buttons__iframe {
  border: none;
  width: 100%;
  display: block;
}

.external-auth-buttons__placeholder {
  .placeholder-rect {
    border-radius: 8px;
  }
}
</style>
